import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Marca } from '../models/marca';

@Injectable({
  providedIn: 'root',
})
export class MarcaService {
  //Url da API

  private url = `${environment.apiUrl}/marcas`;

  constructor(private http: HttpClient) {}

  selecionar(): Observable<Marca[]> {
    return this.http.get<Marca[]>(this.url);
  }

  cadastrar(obj: Marca): Observable<Marca> {
    return this.http.post<Marca>(this.url, obj);
  }

  alterar(obj: Marca): Observable<Marca> {
    return this.http.put<Marca>(this.url, obj);
  }

  ativarDesativar(id: number, ativo: boolean = false): Observable<Marca> {
    return this.http.patch<Marca>(`${this.url}/${id}/ativo?ativo=${ativo}`, null as any);
  }

  // opcional: deletar
  delete(id: number): Observable<any> {
    return this.http.delete(`${this.url}/${id}`);
  }
}
